import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  errorType: '503' | 'under-maintenance' | '404' | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      errorType: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorType: 'under-maintenance' };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log error for monitoring
    console.error("Error caught in error boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.state.errorType === '503') {
        return <Navigate to="/503" replace />;
      } else if (this.state.errorType === '404') {
        return <Navigate to="/404" replace />;
      }
      console.log("Error Boundary says:",this.state?.hasError)
      // return <Navigate to="/under-maintenance" replace />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
